import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Grid, Image } from "semantic-ui-react";
import renderHTML from 'react-render-html';
import "./HomeScreen.scss";
import { Config } from "../../common"
import { UpComing, OnGoing } from "../../components";
import StarButton from "../../components/StarButton";
import { useTranslation } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, {
  Navigation,
  Pagination,
  Thumbs,
  FreeMode,
  Controller,
} from "swiper";
import "swiper/swiper-bundle.css";

import Box from "@mui/material/Box";
import home_banner from "../../assets/home/home_banner.png";
import arrow from "../../assets/home/arrowimages.svg";
import quote from "../../assets/icons/quote.svg";
import stayatstar from "../../assets/home/stayatstar.svg";
import Dinnerwithstars from "../../assets/home/Dinnerwithstars.svg";
import freeflightt from "../../assets/home/freeflightt.svg";
import loremipsum from "../../assets/home/loremipsum.svg";
import { useSelector, useDispatch } from "react-redux";
import { setLoginRedirectUrl } from "../../store/AuthRedux";
import { getTestimonials, getDiduknows, setDiduknow } from "../../store/OrderRedux";
import { setTab } from "../../store/UserRedux";

SwiperCore.use([Navigation, FreeMode, Pagination, Thumbs, Controller]);


const meetYourFavourite = [
  {
    imgUrl: freeflightt,
    title: "Free flight tickets",
    text: "Lorem Ipsum is simply dummy text of the printing and type setting industry.",
  },
  {
    imgUrl: Dinnerwithstars,
    title: "Dinner with starz",
    text: "Lorem Ipsum is simply dummy text of the printing and type setting industry.",
  },
  {
    imgUrl: stayatstar,
    title: "Stay at star hotels",
    text: "Lorem Ipsum is simply dummy text of the printing and type setting industry.",
  },
  {
    imgUrl: loremipsum,
    title: "Bring your buddy",
    text: "Lorem Ipsum is simply dummy text of the printing and type setting industry.",
  },
  {
    imgUrl: loremipsum,
    title: "Lorem Ipsum",
    text: "Lorem Ipsum is simply dummy text of the printing and type setting industry.",
  },
  {
    imgUrl: Dinnerwithstars,
    title: "Lorem Ipsum",
    text: "Lorem Ipsum is simply dummy text of the printing and type setting industry.",
  },
];

const HomeScreen = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const token = useSelector((state) => state.auth.token)
  const testimonials = useSelector((state) => state.order.testimonials)
  const diduknows = useSelector((state) => state.order.diduknows)

  useEffect(() => {
    dispatch(getTestimonials({ token }));
    dispatch(getDiduknows({ token, onSlider: true }));
    dispatch(setLoginRedirectUrl(null));
    dispatch(setTab(0));
    window.scrollTo(0, 0);
  }, []);


  const card_box = () => {
    return (
      <div className="home_flex">
        <div className="dream">
          <p>01</p>
          <div className="drem_card">
            <div className="card-title">Enter the Quiz</div>
            <div className="card-text">
              Lorem Ipsum is simply dummy text of the printing and type setting
              industry.
            </div>
          </div>
        </div>

        <div className="card_arrow">
          <img className="dream-arrow" src={arrow} alt="doc" />
        </div>

        <div className="dream1 dream">
          <p>02</p>
          <div className="drem_card">
            <div className="card-title">Get a giftcard</div>
            <div className="card-text">
              Lorem Ipsum is simply dummy text of the printing and type setting
              industry.
            </div>
          </div>
        </div>
        <div className="card_arrow">
          <img className="dream-arrow" src={arrow} alt="doc" />
          {/* <img className="dream-arrow" src={arrow} alt="doc" /> */}
        </div>
        <div className="dream2 dream">
          <p>03</p>
          {/* <img src={giftCard} alt="doc" /> */}
          <div className="drem_card">
            <div className="card-title">Meet your stars</div>
            <div className="card-text">
              Lorem Ipsum is simply dummy text of the printing and type setting
              industry.
            </div>
          </div>
        </div>
      </div>
    );
  };


  // ---------------------------  ends here ------------------------



  const dream_comes_true = () => {
    return (
      <div className="dinner my-5 py-0 py-md-5">
        <Swiper
          navigation={true}
          className="mySwiper"
          style={{
            "--swiper-navigation-color": "#f5d264",
          }}
          allowTouchMove={false}
        >
          {testimonials ? testimonials.map((item, key) => {
            let newItem = Config.GetLanguageSameLine(item, i18n.language)
            return <SwiperSlide key={key}>
              <Grid>
                <Grid.Column
                  className="destops"
                  mobile={16}
                  tablet={8}
                  computer={8}
                >
                  <div className="dreams_come">
                    <h6 className="dinner-box_tagline">{newItem.heading}</h6>
                    <h4 className="dinner-box_heading my-0 my-md-3">




                      {newItem.title}

                    </h4>
                    <div className="dinner-box_para mb-3 mb-md-4 text-white">
                      {renderHTML(newItem.text || "<p></p>")}
                    </div>
                    <h5 className="dinner-box_tagline">
                      {newItem.name}



                    </h5>
                  </div>
                </Grid.Column>
                <Grid.Column
                  mobile={16}
                  tablet={7}
                  computer={7}
                  className="dream_sec"
                >
                  <div className="hr_videoSeccontainer">
                    <div className="hr_videoSec">
                      <div className="hr_innerVideoSec">
                        <video
                          autoplay="autoplay"
                          onClick={() => {
                            const video = document.getElementById("videoId");
                            if (video.muted) {
                              video.muted = false;
                            } else {
                              video.muted = true;
                            }
                          }}
                          muted
                          loop
                          id="videoId"
                          className="hr_videoMain"
                          width="100%"
                          controls={true}
                        >
                          <source
                            type="video/mp4"
                            src={item.videoURL}
                          ></source>
                        </video>
                      </div>
                    </div>
                  </div>
                </Grid.Column>
                <Grid.Column
                  className="mobiles"
                  mobile={16}
                  tablet={8}
                  computer={8}
                >
                  <div className="dreams_come">
                    <h6 className="dinner-box_tagline">{item.heading}</h6>
                    <h4 className="dinner-box_heading my-0 my-md-3">

                      {/* {item.name} */}
                      {/* - {newItem.title} */}


                      {item.title}

                    </h4>
                    <div className="dinner-box_para mb-3 mb-md-4 text-white">
                      {renderHTML(newItem.text || "<p></p>")}
                    </div>
                    <h5 className="dinner-box_tagline">

                      {/* - {item.title} */}
                      {/* {newItem.name} */}


                      {item.name}

                    </h5>
                  </div>
                </Grid.Column>
              </Grid>
            </SwiperSlide>
          }) : null}
        </Swiper>
      </div>
    );
  };



  //  ------------------------------dreams come true ends here ----------------------------






  // --------------------------- did you know  starts here ------------------------

  const did_you_know = () => {
    return (
      <div className="know mt-5  position-reative didyouknow_sec">
        <Swiper
          style={{
            "--swiper-navigation-color": "#f5d264",
            "--swiper-pagination-color": "#f5d264",
          }}
          id="knowController"
          className="mySwiper2 knowSwiperMain pb-5 pb-md-0"
          slidesPerView="1"
          navigation
          loop={true}
          allowTouchMove={false}

        >
          {diduknows ? diduknows.map((know, key) => {
            let newItem = Config.GetLanguageSameLine(know, i18n.language)
            return <SwiperSlide key={key}>
              <Grid>
                <Grid.Column mobile={16} tablet={8} computer={6}>
                  <div className="hr_videoSeccontainer">
                    <div className="hr_videoSec">
                      <div className="hr_innerVideoSec" style={{ width: 600, padding: 0 }} >
                        <img className="dream_sec_img" src={know.slideImage} style={{ borderRadius: 40 }} />
                      </div>
                    </div>
                  </div>
                </Grid.Column>

                <Grid.Column mobile={16} tablet={8} computer={9}>
                  <img src={quote} alt="quote-image" className="know-box_image mb-4 mb-md-5" />
                  <h3 className="know-box_title mb-3 mb-md-4">{newItem.heading}</h3>
                  <div className="textLimit">
                    {renderHTML(newItem.text || "<p></p>")}
                  </div>
                  <p className="dinner-box_para"><span className="home_para" onClick={() => { dispatch(setDiduknow(know)); history.push("/didyouknowditels") }}>Readmore</span></p>
                  <div className="five_img">
                    <img className="stargroup" src={know.celebrityImage} />
                    <h4>{newItem.celebrityName}</h4>
                  </div>
                </Grid.Column>
              </Grid>
            </SwiperSlide>
          }) : null}
        </Swiper>
      </div>
    );
  };





  // -`-------------------------- did you know ends here ---------------------------

  return (
    <div className="container-fluid home pt-5 px-3 px-md-5">
      <div className="home_backround">
        <Image src={home_banner} />
      </div>
      <div className="home-title" textAlign="center">
        <h2> {t("home.titel1")}</h2>
        <h5> {t("home.Galaxy")}</h5>
        <div className="home_box">
          <StarButton
            background={"mainBg"}
            title={t("home.btn")}
            onClickAction={() => history.push("/contest")}
            disableStar={false}
          />
        </div>
      </div>

      <Box sx={{ width: "100%" }}>
        <div className="superstarz">
          <h2>
            {t("home.titel2")}
            <span> {t("home.titel3")}</span>
          </h2>
          <p>{t("home.para")}</p>
        </div>
        <div className="homeTabs">
          <div className="cards_box">
            <Grid stackable columns={3}>
              {meetYourFavourite.map((contest, key) => (
                <Grid.Column key={key}>
                  <Grid>
                    <Grid.Column
                      textAlign="center"
                      mobile={16}
                      tablet={3}
                      computer={4}
                    >
                      <Image src={contest.imgUrl} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={13} computer={12}>
                      <h5 className="cards_box-title">{contest.title}</h5>
                      <p className="cards_box-text">{contest.text}</p>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
              ))}
            </Grid>
          </div>
          <div className="btnfilled_sec">
            <StarButton
              background={"mainBg"}
              title={t("home.btn")}
              onClickAction={() => history.push("/contest")}
            />
          </div>
        </div>
      </Box>
      <div className="home-title">
        <h4>
          {t("home.titel4")} <span> {t("home.titel5")}</span>
        </h4>
        <p>{t("home.para")}</p>
      </div>
      <div className="ongoing_slider">
        <OnGoing isSlider={true} />
      </div>
      <div className="home-title">
        <h4>
          {t("home.titel6")} <span> {t("home.titel7")} </span>
        </h4>
        <p>{t("home.para")}</p>
      </div>
      <UpComing isSlider={true} />
      <div className="btnfilled_sec">
        <StarButton
          background={"mainBg"}
          title={t("home.btn")}
          onClickAction={() => {
            dispatch(setTab(1));
            history.push("/contest");
          }}
        />
      </div>
      <div className="home-title">
        <h4>
          {t("home.titel8")} <span> {t("home.titel9")} </span>
        </h4>
        <p>{t("home.para")}</p>
      </div>
      {card_box()}
      <div className="btnfilled_sec card_box_botton">
        <StarButton
          background={"mainBg"}
          title={t("home.btn")}
          onClickAction={() => history.push("/contest")}
        />
      </div>
      {dream_comes_true()}
      <div className="home-title">
        <h4>
          {t("home.titel10")}
          <span> {t("home.titel11")}</span>
        </h4>
        <p>{t("home.para")}</p>
      </div>
      {did_you_know()}
      <Grid>
        <Grid.Column textAlign="center">
          <div className="btnfilled_sec">
            <StarButton
              background={"mainBg"}
              title={"View all"}
              onClickAction={() => history.push("/didyouknow")}
            />
            {/* <Button className="demobt">button</Button> */}
          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
};

export default HomeScreen;
